import '@/assets/tailwind.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify'; // 👈 Importera vuetify

import axios from 'axios';

axios.defaults.withCredentials = true;

axios.get('/api/auth/session', { withCredentials: true })
  .then(res => {
    store.commit('setUser', res.data.user);
  })
  .catch(() => {
    store.commit('logout');
  });

// 👇 Lägg till `.use(vuetify)`
createApp(App).use(router).use(store).use(vuetify).mount('#app');
